/** @format */

import React, { useState } from "react";

interface GradientButtonProps {
   buttonText: string;
   icon?: any;
   classname: string;
   onclick: () => void;
   disabled: boolean;
}

const GenerateButton = ({ buttonText, icon, classname, onclick, disabled }: GradientButtonProps) => {
   return (
      <div>
         <button
            disabled={disabled}
            onClick={onclick}
            className={`${classname} flex justify-center text-[1.5rem] font-semibold items-center gap-2 py-[0.5rem] px-[1rem] w-full h-full text-turquoise border-2 border-turquoise bg-black rounded-lg active:bg-[#1c1c1c]`}>
            {buttonText}
            <span className="mt-[-0.2rem]">{icon}</span>
         </button>
         {disabled && (
            <div
               className="md:hidden w-[100%] h-full bg-black opacity-60 bottom-0 left-0 right-0 mx-auto rounded-full"
               style={{ position: "absolute" }}></div>
         )}
      </div>
   );
};

export default GenerateButton;
